import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '@modules/auth';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AppStateService } from '../store/app-state.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, private appStateService: AppStateService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.appStateService.state.currentUser?.jwToken;
    if (authToken) {
      if (!request.url.includes(environment.sharpenApi)) {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json; charset=utf-8',
            Accept: 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: `Api-Key ${environment.sharpenApiKey}`,
          },
        });
      }
    }
    return next.handle(request).pipe(tap(() => {
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 400) {
            const toastrService = this.injector.get(ToastrService);
            toastrService.error(err.error.Message);
            const router = this.injector.get(Router);
            // router.navigate(['']);
          }
          if (err.status !== 401) {
            return;
          }
          try {
            const authService = this.injector.get(AuthService);
            authService.logout();
          } catch (e) {
            console.error('error while logout: ', e);
          }
        }
      }));
  }
}
